export interface IInActiveReasonReport {
    centerId: number,
    centerAlias: string,
    recipientAlias: string,
    registeredDate: string,
    recipientBloodType: string,
    cpRa4: number,
    mosWaiting: number,
    gender: string,
    chip: string,
    inActiveReason: string,
    lastUpdated: string
}